/**
 * Global design tokens – single source of truth for the UI.
 * Use these across all pages for consistent spacing, colors, and typography.
 */

export const tokens = {
  colors: {
    // Brand (existing green – do not change primary identity)
    brand: {
      500: '#114417',
      600: '#0d2e11',
      700: '#0a2610',
    },
    // Surfaces
    surface: {
      0: '#FAFBFC',
      1: '#FFFFFF',
    },
    border: 'rgba(0, 0, 0, 0.08)',
    borderHover: 'rgba(0, 0, 0, 0.12)',
    // Text
    text: {
      1: '#1A1D23',
      2: '#6B7280',
      muted: '#9CA3AF',
    },
    // Semantic (badges, status dots)
    success: '#10B981',
    warning: '#F59E0B',
    danger: '#EF4444',
    info: '#3B82F6',
  },
  elevation: {
    shadowSm: '0 1px 3px rgba(0, 0, 0, 0.06)',
    shadowMd: '0 4px 12px rgba(0, 0, 0, 0.08)',
  },
  radius: {
    card: 16,
    pill: 999,
    button: 12,
    input: 12,
  },
  spacing: {
    0: 0,
    1: 4,
    2: 8,
    3: 12,
    4: 16,
    5: 20,
    6: 24,
    8: 32,
    10: 40,
  },
  typography: {
    pageTitle: { fontSize: 18, fontWeight: 600 },
    sectionTitle: { fontSize: 15, fontWeight: 600 },
    body: { fontSize: 14 },
    bodySmall: { fontSize: 13 },
    caption: { fontSize: 12 },
  },
};

export default tokens;
